/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.14.0
 * @since 1.13.0
 */

import { FC } from 'react';

import BadgeStatus, { EBadgeStatus } from '../../../components/common/Badge/BadgeStatus';
import ArrowTooltip from '../../../components/common/Tooltip/Tooltip';
import { ELocaleKeys } from '../../../modules/internationalization/intConstants';
import { IPageSubscriberIdStatusTranslation } from '../../../modules/internationalization/types/pages/subscriberId';
import { IAttrStyled } from '../../../types/globalTypes';
import { formatDate } from '../../../utils/formatText';
import { stringFormatParams } from '../../../utils/stringFormat';
import { ISubscriberIdStatus } from '../types';
import { SubscriberIdStatusStyled } from './styled/SubscriberIdStatusStyled';


export interface ISubscriberIdStatusProps extends ISubscriberIdStatus, IAttrStyled {
    title: string;
    tooltip?: string;
    translation: IPageSubscriberIdStatusTranslation;
}

const SubscriberIdStatus: FC<ISubscriberIdStatusProps> = ({
                                                              children,
                                                              className,
                                                              date,
                                                              isBlocked,
                                                              lockDate,
                                                              name,
                                                              translation,
                                                              title,
                                                              tooltip,
                                                          }) => {
    return (
        <SubscriberIdStatusStyled className={className}>
            <div className="subscriber-id__title subscriber-id__title_light">{title}</div>
            <ArrowTooltip
                isHintMessage
                message={tooltip}
                placement="top-start"
                title={tooltip ? name : ''}
            >
                <div>
                    <BadgeStatus
                        className="subscriber-id-status__badge"
                        isDisableTooltip={!!tooltip}
                        status={isBlocked ? EBadgeStatus.blocked : EBadgeStatus.active}
                        text={date
                            ? stringFormatParams(translation.common, {
                                [ELocaleKeys.date]: formatDate(date),
                                [ELocaleKeys.status]: name,
                            })
                            : name}
                    />
                </div>
            </ArrowTooltip>
            {
                lockDate && (
                    <div className="subscriber-id-status__lock-date">
                        <ArrowTooltip
                            placement="top"
                            title={translation.lockTooltip}
                            titleAlign="center"
                        >
                            <div>
                                <BadgeStatus
                                    isDisableTooltip
                                    status={EBadgeStatus.blocked}
                                    text={stringFormatParams(translation.lock,
                                        { [ELocaleKeys.date]: formatDate(lockDate) },
                                    )}
                                />
                            </div>
                        </ArrowTooltip>
                    </div>
                )
            }
            {
                children && <div className="status__content">{children}</div>
            }
        </SubscriberIdStatusStyled>
    );
};

export default SubscriberIdStatus;
